import { useEffect } from "react"

export function Datepicker({ id, onChange, className }) {
  useEffect(() => {
    import("litepicker").then(({ Litepicker }) => {
      new Litepicker({
        element: document.getElementById(id),
        setup: (picker) => {
          picker.on("selected", (date1, date2) => {
            if (onChange !== undefined) {
              onChange(date1, date2)
            }
          })
        }
      })
    })
  }, [])

  return (
    <>
      <input
        placeholder="Välj datum"
        id={id}
        className={className}
        autoComplete="off"
      />
    </>
  )
}
